export default "__VITE_ASSET__BSRiBPj7__"